const calpak = window.calpak
calpak.timers = calpak.timers || {}

// calpak.hideSkusCalifornia = ["ACO2001-CHEETAH", "ACO2001-DRAGONFRUIT", "ACO2001-DUNE", "ACO2001-MOSS", "ACO2001-PINK-SAND", "ACS2301-CHEETAH", "ACS2301-DRAGONFRUIT", "ACS2301-PINK-SAND", "ALP2213-BLACK", "ALP2217-DAISY", "ALP2217-GREEN-CHECKERBOARD", "ALP2217-ORCHID-FIELDS", "ALP2217-PINK-GRID", "ALP2217-SKY", "ALP2217-WALNUT", "ALT2201-BUBBLEGUM", "ALT2201-CELERY", "ALT2201-COPPER", "ALT2201-GOLD", "ALT2201-GUNMETAL", "ALT2201-KHAKI", "ALT2201-LILAC", "ALT2201-NAVY", "ALT2201-PLUM", "ALT2201-WATERMELON", "AMB2201-COPPER", "ATC2001-CHEETAH", "ATC2001-DAISY", "ATC2001-ORCHID-FIELDS", "ATC2001-PINK-SAND", "ATC2001-POLKA-DOT", "ATL2301-BLACK", "ATL2301-MOSS", "AWH2101-CHEETAH", "AWH2101-DAISY", "AWH2101-GREEN-CHECKERBOARD", "AWH2101-MAUVE", "AWH2101-POLKA-DOT", "AWH2101-WALNUT", "BB1901-BUBBLEGUM", "BB1901-CELERY", "BB1901-CHOCOLATE", "BB1901-COPPER", "BB1901-GOLD", "BB1901-GREEN-APPLE", "BB1901-GUNMETAL", "BB1901-LILAC", "BB1901-MATTE-BLACK", "BB1901-NAVY", "BB1901-OATMEAL", "BB1901-PLUM", "BB1901-ROSE-GOLD", "BB1901-ROSE-QUARTZ", "BB1901-WATERMELON", "BBM2201-BUBBLEGUM", "BBM2201-CELERY", "BBM2201-COPPER", "BBM2201-GREEN-APPLE", "BBM2201-LILAC", "BBM2201-WATERMELON", "BBM2201-WINTER-SKY", "BBT2301-AMETHYST", "BBT2301-CACAO", "BBT2301-CANYON", "BBT2301-DRAGONFRUIT", "BBT2301-GLACIER", "BBT2301-JUNIPER", "BBT2301-OBSIDIAN", "BBT2301-STORM", "BPH2201-JUNIPER", "BPL2001-COPPER", "BPL2001-GOLD", "BPL2001-GUNMETAL", "BPL2001-LILAC", "BPL2001-NAVY", "BPL2001-PLUM", "BPL2001-ROSE-GOLD", "BPL2001-WATERMELON", "BPM2201-BUBBLEGUM", "BPM2201-CHOCOLATE", "BPM2201-COPPER", "BPM2201-GOLD", "BPM2201-GREEN-APPLE", "BPM2201-GUNMETAL", "BPM2201-KHAKI", "BPM2201-LILAC", "BPM2201-MATTE-BLACK", "BPM2201-NAVY", "BPM2201-OATMEAL", "BPM2201-PLUM", "BPM2201-ROSE-QUARTZ", "BPM2201-WATERMELON", "BPT2201-AMETHYST", "BPT2201-CACAO", "BPT2201-CANYON", "BPT2201-DRAGONFRUIT", "BPT2201-FLAME", "BPT2201-GLACIER", "BPT2201-JUNIPER", "BPT2201-OBSIDIAN", "BPT2201-STORM", "CBH2201-AMETHYST", "CBH2201-CACAO", "CBH2201-CANYON", "CBH2201-DRAGONFRUIT", "CBH2201-FLAME", "CBH2201-GLACIER", "CBH2201-JUNIPER", "CBH2201-OBSIDIAN", "CBH2201-STORM", "DLL2201-CELERY", "DLL2201-COPPER", "DLL2201-GOLD", "DLL2201-GUNMETAL", "DLL2201-KHAKI", "DLL2201-LILAC", "DLL2201-PLUM", "DLL2201-ROSE-QUARTZ", "DLL2201-WATERMELON", "DRL2301-DRAGONFRUIT", "DSM1901-COPPER", "DSM1901-LILAC", "DSM1901-OATMEAL", "DSM1901-ROSE-QUARTZ", "DSR2201-DRAGONFRUIT", "DST7019-CHEETAH", "DST7019-DRAGONFRUIT", "DST7019-DUNE", "DST7019-PINK-SAND", "DTL2301-AMETHYST", "DTL2301-CACAO", "DTL2301-CANYON", "DTL2301-DRAGONFRUIT", "DTL2301-FLAME", "DTL2301-GLACIER", "DTL2301-JUNIPER", "DTL2301-OBSIDIAN", "DTL2301-STORM", "KDB2001-CHEETAH", "KGL2001-BLACK", "KGL2001-MAUVE", "KSB2001-BLACK", "KSB2001-CHEETAH", "KSB2001-DAISY", "KSB2001-GREEN-CHECKERBOARD", "KSB2001-GROOVY-BLUE", "KSB2001-MAUVE", "KSB2001-MODERN-ABSTRACT", "KSB2001-ORANGE-GRID", "KSB2001-ORCHID-FIELDS", "KSB2001-PINK-GRID", "KSB2001-POLKA-DOT", "KSB2001-RETRO-SUNSET", "KTB2001-ORCHID-FIELDS", "KZB2001-DAISY", "KZB2001-MAUVE", "KZB2001-WALNUT", "LCO8000-PACIFIC", "LCO8000-SMOKE", "LTE1020-AMETHYST", "LTE1020-CANYON", "PC1601-DAISY", "PC1601-WALNUT", "PCC2201-DAISY", "PCC2201-GREEN-CHECKERBOARD", "PCC2201-GROOVY-BLUE", "PCC2201-MODERN-ABSTRACT", "PCC2201-MOSS", "PCC2201-ORANGE-GRID", "PCC2201-ORCHID", "PCC2201-ORCHID-FIELDS", "PCC2201-PALM", "PCC2201-PINK-GRID", "PCC2201-PINK-SAND", "PCC2201-RETRO-SUNSET", "PCC2201-WALNUT", "PCL2301-BLACK", "PCL2301-CHEETAH", "PCL2301-DAISY", "PCL2301-DRAGONFRUIT", "PCL2301-GROOVY-BLUE", "PCL2301-LAGOON", "PCL2301-MODERN-ABSTRACT", "PCL2301-ORANGE-GRID", "PCL2301-ORCHID", "PCL2301-ORCHID-FIELDS", "PCL2301-PALM", "PCL2301-PINK-GRID", "PCL2301-PINK-SAND", "PCL2301-POLKA-DOT", "PCL2301-RETRO-SUNSET", "PCL2301-SPECKLE", "PCL2301-WALNUT", "PCS2301-BLACK", "PCS2301-CHEETAH", "PCS2301-DAISY", "PCS2301-DRAGONFRUIT", "PCS2301-GROOVY-BLUE", "PCS2301-LAGOON", "PCS2301-MOSS", "PCS2301-ORANGE-GRID", "PCS2301-ORCHID", "PCS2301-ORCHID-FIELDS", "PCS2301-PALM", "PCS2301-PINK-SAND", "PCS2301-POLKA-DOT", "PCS2301-RETRO-SUNSET", "PCS2301-SPECKLE", "PCS2301-WALNUT", "THY2201-AMETHYST", "THY2201-CANYON", "THY2201-GLACIER", "THY2201-JUNIPER", "THY2201-OBSIDIAN", "TLH2301-CELERY"];
calpak.hideSkusCalifornia = [];

calpak.setLocation = async () => {
    async function fetchUserLocation() {
        // console.log('-------------- setLocation - fetchUserLocation-- calpak-initialize')
        const res = await fetch('https://api.techyscouts.io/calpak/location/index.php');
        calpak.userLocationData = await res.json();
        calpak.userCountryCode = calpak.userLocationData.country_code
        calpak.userRegionCode = calpak.userLocationData.region_code
        calpak.userRegionName = calpak.userLocationData.region_name
        calpak.userFreeShipping = calpak.userLocationData.free_shipping
    }

    const CACHE_KEY = "userLocationCache";
    const CACHE_EXPIRY = 60 * 60 * 1000;
    const cachedData = localStorage.getItem(CACHE_KEY);
    let data;

    if (cachedData) {
        const { timestamp, locationData } = JSON.parse(cachedData);
        if (Date.now() - timestamp < CACHE_EXPIRY) {
            data = locationData;
            calpak.userLocationData = data;
            calpak.userCountryCode = data.country_code
            calpak.userRegionCode = data.region_code
            calpak.userRegionName = data.region_name
            calpak.userFreeShipping = data.free_shipping
        }
    }

    if (!data) {
        await fetchUserLocation();
        data = calpak.userLocationData;
        localStorage.setItem(
            CACHE_KEY,
            JSON.stringify({
                timestamp: Date.now(),
                locationData: data,
            })
        );
    }
};


async function fetchProducts() {
    // NB change this url if not on Edgemesh server
    // /collections/all?view=json excludes product.tags contains "do not display"

    const cacheUrl = window.location.hostname === 'www.calpaktravel.com' ?
        '/collections/all?view=json' :
        '/collections/all?view=json&em-default-max-age=300';

    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), 15000);

    try {
        const response = await fetch(cacheUrl, { signal: controller.signal });

        if (!response.ok) {
            throw new Error(`Product catalog request failed: ${response.status}`);
        }

        return await response.json();
    } finally {
        window.clearTimeout(timeoutId);
    }
}

//calpak.setLocation();

fetchProducts()
    .then((response) => {
        calpak.products = calpak.collect(response.products || []);
        calpak.collections = calpak.collect(response.collections || []);
    })
    .catch((error) => {
        console.error('[calpak] Failed to load product catalog', error);
        calpak.products = calpak.collect([]);
        calpak.collections = calpak.collect([]);
    })
    .finally(() => {
        calpak.timers.productsLoaded = performance.now().toFixed(0);
        document.dispatchEvent(new Event('products:loaded'));
    });

